<dialog
  #captchaDialog
  id="captchadialog"
  aria-labelledby="MY-MODAL-TItLE"
  class="fdx-c-dialog fdx-c-dialog--">
  <div class="fdx-c-dialog__header">
    <form method="dialog">
      <button
        class="fdx-c-dialog__header__btn-close fdx-c-button fdx-c-button--icon"
        aria-label="close modal message: lorem ipsum">
        <svg class="fdx-c-icon" aria-hidden="true">
          <use href="#cross"></use>
        </svg>
      </button>
    </form>
  </div>
  <div class="fdx-c-dialog__main">
    <h3 class="fdx-c-dialog__main__title" id="MY-MODAL-TItLE">
      <span class="fdx-u-visual-hidden">Error:</span>Kod captcha wygasł
    </h3>
    <p class="fdx-c-paragraph fdx-u-align--center">Przepisz wyrazy z obrazka</p>
    <div class="fdx-o-grid fdx-o-grid--max-width">
      <form [formGroup]="captchaForm">
        <div class="fdx-o-grid__row fdx-u-mb--10">
          <div class="fdx-o-grid__item fdx-u-align--center">
            <!-- <div class="fdx-o-grid__row">
              <div class="fdx-o-grid__item">
                <p class="fdx-u-font-size--small fdx-u-color--purple">
                  Przepisz wyrazy z obrazka
                </p>
              </div>
            </div> -->

            <div
              class="fdx-o-grid__row fdx-o-grid__row--center fdx-u-align--center">
              <div>
                <div class="fdx-o-grid__row">
                  <div
                    class="fdx-c-form-group fdx-c-form-group--top-label"
                    [ngClass]="{
                            'fdx-c-form-group--is-invalid':
                              captchaInput?.touched && captchaInput?.invalid,
                          }">
                    <span class="fdx-c-form-group__item">
                      @if (storeService.getCaptchaB64()) {
                      <img
                        [src]="
                          'data:image/jpeg;base64,' +
                          storeService.getCaptchaB64()
                        "
                        alt="CAPTCHA Image"
                        style="width: 200px; height: 40px" />
                      } @if (!storeService.getCaptchaB64()) {
                      <div
                        class="fdx-o-grid__row fdx-o-grid__row--center"
                        style="width: 200px; height: 40px">
                        @if (captchaLoadingError()) {
                        <div
                          role="alert"
                          id="alertID"
                          class="fdx-c-form-group__message fdx-c-form-group__message--has-message fdx-u-color--error">
                          <div
                            class="fdx-c-form-message__icon"
                            style="margin-right: 5px">
                            <svg
                              class="fdx-c-icon"
                              aria-hidden="true"
                              focusable="false"
                              role="presentation">
                              <use xlink:href="#utility_cross-fat"></use>
                            </svg>
                          </div>
                          <span>Błąd ładowania obrazka.</span>
                        </div>
                        } @if (!captchaLoadingError()) {
                        <div
                          class="fdx-c-loader fdx-c-loader--medium fdx-o-grid__item--center"></div>
                        }
                      </div>
                      }
                      <div
                        class="fdx-c-form-group__input"
                        style="width: 200px; height: 40px; margin-top: 4px">
                        <input
                          type="text"
                          class="fdx-u-px--4 fdx-u-bg-color--white"
                          id="captcha_input"
                          formControlName="captcha_input"
                          [maxLength]="20"
                          style="width: 200px; height: 40px" />
                      </div>
                    </span>
                    <app-form-field-error-messages [formField]="captchaInput">
                    </app-form-field-error-messages>
                  </div>
                </div>
              </div>
              <div style="padding-left: 5px">
                <div class="fdx-o-grid__row">
                  <div class="fdx-o-grid__item">
                    <button
                      class="fdx-c-button fdx-c-button--square-condensed fdx-c-button--primary fdx-u-border--none fdx-u-bg-color--purple fdx-u-color--white"
                      (click)="reloadCaptcha()">
                      <div class="fdx-c-button__icon" aria-hidden="true">
                        <svg
                          class="fdx-c-icon"
                          aria-hidden="true"
                          focusable="false"
                          role="presentation">
                          <use xlink:href="#utility_sync"></use>
                        </svg>
                      </div>
                    </button>
                  </div>
                </div>
                <div class="fdx-o-grid__row">
                  <div class="fdx-o-grid__item">
                    <button
                      class="fdx-c-button fdx-c-button--square-condensed fdx-c-button--primary fdx-u-border--none fdx-u-bg-color--purple fdx-u-color--white fdx-u-mt--1">
                      <div class="fdx-c-button__icon" aria-hidden="true">?</div>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <app-form-error-message
          [submitException]="submitException()"
          [form]="captchaForm">
        </app-form-error-message>

        <div class="fdx-o-grid__row fdx-o-grid__row--center fdx-u-mb--5">
          <app-submit-button
            [isLoading]="isSubmitLoading()"
            [isDisabled]="captchaForm.invalid"
            [buttonText]="'DALEJ'"
            (clickEvent)="onSubmit()">
          </app-submit-button>
        </div>
      </form>
    </div>
  </div>
  <div class="fdx-c-dialog__footer"></div>
</dialog>
